import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import "./Hero.css";

import Wiz2 from "../assets/pictures/hero-1.webp";
import Wiz8 from "../assets/pictures/sandra-vogue.webp";
import Wiz9 from "../assets/pictures/sandra-kanapa.webp";
import BgHero from "../assets/pictures/hero-4.webp";

const images = [Wiz9, Wiz2, Wiz8, BgHero];

const Hero = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // zmiana co 4 sekundy

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-container">
      {/* Slider fade */}
      <div className="hero-slider">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Slide ${index}`}
            className={index === currentImageIndex ? "active" : ""}
          />
        ))}
      </div>

      {/* Overlay */}
      <div className="hero-overlay" />

      {/* Content */}
      <div className="hero-content">
        <div className="hero-content-border">
          <h1>WITAM W PIĘKNYCH WNĘTRZACH</h1>
          <p>Zaprojektuję wnętrze Twojego wymarzonego domu</p>
        </div>
      </div>

      {/*
      <Link to="/kontakt" style={{ zIndex: 2, position: "relative" }}>
        <button className="btn">SKONTAKTUJ SIĘ ZE MNĄ</button>
      </Link>
      */}
    </div>
  );
};

export default Hero;
